import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  TextField,
  FormHelperText,
  Typography,
  Avatar,
  InputAdornment,
  ClickAwayListener,
  Collapse,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles, styled } from "@mui/styles";
import React, { useEffect, useCallback } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../assets/images/arrowLinkedGoal.svg";
import personalGoal from "../../assets/images/personal-goal.svg";
import { Navigate } from "react-router";
import { ReactComponent as TrashRed20 } from "../../assets/images/trashRed20.svg";
import { ReactComponent as Plus20 } from "../../assets/images/plus20.svg";
import ConfirmDialog from "../../components/ConfirmDialog";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import * as yup from 'yup';
import { useFormik } from 'formik';
import myFeedback from "../../services/myFeedback.service";
import Icon from '@mui/material/Icon';
import * as Util from "../../services/global.service";
import debounce from 'lodash.debounce';
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import Search from "@mui/icons-material/Search";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IconFeedback from "../../constants/IconFeedback";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles({
  boxLeft: {
    width: "25%",
    "padding-bottom": "25px",
  },
  boxRight: {
    width: "75%",
    "padding-bottom": "25px",
  },
  input: {
    '& div > input': {
      height: '12px',
      position: "relative"
    }
    , "&.MuiFormControl-root": { "margin-top": "10px" }
  },
  styleTag: {
    '& div > .MuiOutlinedInput-root': {
      '& .MuiChip-root': {
        backgroundColor: "#EFF6F4",
        color: "#404349",
        borderRadius: "3px",
        '& .MuiChip-deleteIcon': {
          // color: "#ffffff",
        }
      },
    },
  },
  select: {
    '& div ': {
      padding: "8.5px 8.5px 8.5px 15px"
    },
  },
  selectError: {
    background: "#CC6058",
    '& div ': {
      padding: "8.5px 8.5px 8.5px 15px"
    },
    '& fieldset': {
      "border-color": "#CC6058"
    },
  },
});


const DialogGiveFeedback = (props) => {
  const { open, close, data, openSuccessAddDialog, dataEmployee, dataOwner, type, selectEmployee, } = props
  const classes = useStyles();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [question, setQuestion] = React.useState([]);
  const [loopQuestion, setLoopQuestion] = React.useState([]);
  const [statusSave, setStatusSave] = React.useState(false);
  const [discardDialog, setDiscardDialog] = React.useState(false);
  const [confirmSendDialog, setConfirmSendDialog] = React.useState(false);
  const [dataAllEmployee, setDataAllEmployee] = React.useState([]);
  const [dataAllEmployeeSendTo, setDataAllEmployeeSendTo] = React.useState([]);
  const [itemsRequestFor, setItemsRequestFor] = React.useState([]);
  const [itemsSendTo, setItemsSendTo] = React.useState([]);
  const [selectedSendTo, setSelectedSendTo] = React.useState([]);
  const [onSubmit, setOnSubmit] = React.useState(false);
  const validationSchema = yup.object({
    title: yup.string().required(t('admin.inputForm.msgError.code')),
  });
  const formik = useFormik({
    initialValues: {
      sendTo: [],
      title: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (checkData() === true) {
        setConfirmSendDialog(true)
      }
    },
  });

  let checkData = () => {
    let check = true
    if (Util.formatData(selectedSendTo, []).length === 0) {
      check = false
    } else if (Util.formatData(question, []).length === 0) {
      check = false
    } else {
      let mapFeedback = Util.formatData(question, []).filter((rs) => Util.formatData(rs?.comment, false) === false && Util.formatData(rs?.emotion, false) === false)
      if (mapFeedback.length > 0) {
        check = false
      }
    }
    let mapFeedback = Util.formatData(question, []).filter((rs) => Util.formatData(rs?.question, false) === false)
    if (mapFeedback.length > 0) {
      check = false
    }
    return check
  }
  useEffect(() => {
    if (open) {
      setSelectedSendTo([]);
      myFeedback.getListFeedbackQuestionMaster().then((rs) => {
        setQuestion(Util.formatData(rs?.data?.feedback_question, []))
        setLoopQuestion(Util.formatData(rs?.data?.feedback_question, []))
      })
      formik.resetForm()
      setStatusSave(false)
      if (Util.formatData(dataOwner, false) !== false) {
        myFeedback.getListEmployeeByPermission({
          "code": "all"
        },dataOwner?.serial).then((rs) => {
          setDataAllEmployeeSendTo(Util.formatData(rs?.data?.employee))
          setItemsSendTo(Util.formatData(rs?.data?.employee))
          if (dataOwner?.serial !== selectEmployee?.serial) {
            let self = Util.formatData(rs?.data?.employee, []).filter((rs) => rs?.serial === selectEmployee?.serial)
            setSelectedSendTo(self)
          }
        })
      }
      setOnSubmit(false)
    } else {
      setLoopQuestion([])
      setQuestion([])
      formik.resetForm()
    }
  }, [open]);

  const handleCloseDialog = () => {
    close(false);
  };
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }))
  let onChange = (e, index) => {
    if (Util.formatData(question, []).length > 1) {
      let data = JSON.parse(JSON.stringify(question))
      data[index].question = e.target.value
      setQuestion(data)
    }
  }
  let onChanges = (e, index, type) => {
    if (Util.formatData(question, []).length > 1) {
      let data = JSON.parse(JSON.stringify(question))
      data[index][type] = type === "emotion" ? data[index][type] === e ? "" : e : e.target.value
      setQuestion(data)
    }
  }
  const handleCancel = () => {
    setDiscardDialog(true)
  }
  const handleDiscardDialog = (value) => {
    setDiscardDialog(value)
  };

  const handleDiscardChangeConfirm = () => {
    setDiscardDialog(false)
    close()
  };
  const handleConfirmSendDialog = (value) => {
    setConfirmSendDialog(value)
  };

  const handleSendConfirm = () => {
    submit()
    setConfirmSendDialog(false)
    close()
  };

  const handleSubmit = () => {
    if (statusSave === false) {
      setStatusSave(true)
    }
    formik.submitForm()
    setOnSubmit(true)
  }
  const [opens, setOpens] = React.useState(false);
  const [focusSearchSendTo, openFocusSearchSendTo] = React.useState(false);
  const [selectSearchSendTo, setSelectSearchSendTo] = React.useState([]);
  const handleCloseSendTo = (event) => {
    openFocusSearchSendTo(false)
    if (Util.formatData(document.getElementById('searchEmployeeSendTo'), false) !== false) {
      document.getElementById('searchEmployeeSendTo').value = ""
    }
  };
  const handleFocusSendTo = () => {
    setSelectSearchSendTo([])
    openFocusSearchSendTo(true)
  };
  const changeHandlerSendTo = event => {
    // setQuery(event.target.value);
    dataSerachsSendTo(event.target.value)
  };
  const debouncedChangeHandlerSendTo = useCallback(
    debounce(changeHandlerSendTo, 500), console.log()
    , []);
  const onclickSelectSendTo = (data) => {
    formik.setFieldValue("sendTo", data)
    openFocusSearchSendTo(false)
  }
  const handleClearClickSendTo = () => {
    formik.setFieldValue("sendTo", '')
  };
  const dataSerachsSendTo = async (data) => {
    let result = []
    let dataSerach = JSON.parse(JSON.stringify(dataAllEmployeeSendTo))
    if (data !== "") {
      result = dataSerach.filter((item) => {
        return Object.keys(item).some((key) => {
          if (key === 'fullname' || key === 'code') {
            return item[key].toString().toLowerCase().indexOf(data.toString().toLowerCase()) !== -1;
          }
        });
      });
    } else {
      result = dataSerach;
    }
    await setItemsSendTo(result)
  };
  const formikChangeSendTo = (val, field) => {
    formik.setFieldValue(field, val)
    setSelectedSendTo(val)
  }
  const handleSelectAllClickSendTo = (event) => {
    if (itemsSendTo.length > 0 && selectedSendTo.length !== itemsSendTo.length) {
      const newSelecteds = dataAllEmployeeSendTo.map((n) => n);
      setSelectedSendTo(newSelecteds);
      return;
    }
  };
  const handleDeSelectAllClickSendTo = (event) => {
    if (itemsSendTo.length > 0 && selectedSendTo.length > 0) {
      setSelectedSendTo([]);
    }
  };

  const handleClickSendTo = (event, data) => {
    const selectedIndexSendTo = selectedSendTo.indexOf(data);
    let newSelectedSendTo = [];

    if (selectedIndexSendTo === -1) {
      newSelectedSendTo = newSelectedSendTo.concat(selectedSendTo, data);
    } else if (selectedIndexSendTo === 0) {
      newSelectedSendTo = newSelectedSendTo.concat(selectedSendTo.slice(1));
    } else if (selectedIndexSendTo === selectedSendTo.length - 1) {
      newSelectedSendTo = newSelectedSendTo.concat(selectedSendTo.slice(0, -1));
    } else if (selectedIndexSendTo > 0) {
      newSelectedSendTo = newSelectedSendTo.concat(
        selectedSendTo.slice(0, selectedIndexSendTo),
        selectedSendTo.slice(selectedIndexSendTo + 1),
      );
    }
    setSelectedSendTo(newSelectedSendTo);
  };
  const isSelectedSendTo = (serial) => selectedSendTo.indexOf(serial) !== -1;
  const [opensSendTo, setOpensSendTo] = React.useState(false);
  const submit = () => {
    let dataSendTo = []
    for (let indexs = 0; indexs <= selectedSendTo.length - 1; indexs++) {
      dataSendTo.push(selectedSendTo[Object.keys(selectedSendTo)[indexs]].serial)
    }
    for (let idx = 0; idx <= question.length - 1; idx++) {
      question[idx].no = idx + 1
    }
    myFeedback.giveFeedback({
      "type": "normal",
      "ref_id": "",
      "request_for": "",
      "sent_to": dataSendTo,
      "title": formik.values.title,
      "feedback_question": question
    }).then((rs) => {
      close()
      openSuccessAddDialog()
    }).catch((err) => {

    })
  }

  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="md" PaperProps={{ sx: { padding: '30px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" fontWeight="600" sx={{ padding: "0 0 20px" }}>
        {t('feedback.label.giveFeedback')}
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ ".Mui-error .MuiOutlinedInput-notchedOutline": { "border-color": "#CC6058 !important" }, padding: "0", ".MuiFormHelperText-root": { color: "#CC6058 !important", } }}>
        {/* fontWeight: "500", fontSize: "14px", lineHeight: "24px", */}
        <Box >
          <Box sx={{ width: "100%", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
            <Typography pt="20px" color="#404349" fontWeight="500" fontSize={16} lineHeight="20px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t('feedback.label.giveFeedbackTo')}<span style={{ color: "#CC6058 ", fontWeight: "400" }}> *</span></Typography>
            <ClickAwayListener onClickAway={handleCloseSendTo} >
              <Box sx={{ position: "relative" }}>
                <Box sx={{ position: "relative" }} onClick={e => handleFocusSendTo(true)} >
                  <Box sx={{ '.MuiOutlinedInput-notchedOutline': { "border-color": onSubmit === true ? selectedSendTo !== "" && selectedSendTo !== undefined && selectedSendTo !== null && selectedSendTo.length > 0 ? "#E4E7EA" : "#CC6058" : "#E4E7EA" }, ".MuiOutlinedInput-root": { borderRadius: "10px", padding: "8px", borderColor: "#E4E7EA" } }} >
                    <Autocomplete
                      multiple
                      id="checkboxes-tags-demo"
                      size="small"
                      fullWidth
                      options={itemsSendTo}
                      disableCloseOnSelect
                      value={selectedSendTo}
                      onChange={(event, newValue) => {
                        formikChangeSendTo(newValue, "sendTo")
                      }}
                      classes={{ root: classes.styleTag }}
                      getOptionLabel={(option) => option?.fullname}
                      renderOption={() => null}
                      open={opens}
                      onOpen={() => {
                        setOpensSendTo(false);
                      }}
                      onClose={() => openFocusSearchSendTo(false)}
                      style={{ width: "100%", color: "#404349" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={t('feedback.label.selectGiveFeedbackTo')}
                          InputLabelProps={{
                            ...params.inputProps,
                            shrink: true,
                          }}
                        />
                      )}
                    />
                    {onSubmit === true ? selectedSendTo !== "" && selectedSendTo !== undefined && selectedSendTo !== null && selectedSendTo.length > 0 ? <></> : (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                  </Box>
                </Box>
                <Box sx={{ position: "absolute", width: "100%", zIndex: "999" }}>
                  <Collapse in={focusSearchSendTo}>
                    <Box sx={{ width: "100%", border: "1px solid #CED4DA", background: "#FFFFFF", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", borderRadius: "8px" }} p="15px">
                      <TextField
                        id="searchEmployeeSendTo"
                        fullWidth
                        placeholder={t('feedback.label.searchEmployee')}
                        size="small"
                        sx={{ background: "#fff", "input": { padding: "9px 14px" } }}
                        className="searchTextField-h40"
                        autoComplete='off'
                        onChange={debouncedChangeHandlerSendTo}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search style={{ color: "#C4C4C4" }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Typography mt="10px" color="#888F9D" fontSize={12} lineHeight="17.94px" fontWeight={400} >{t('feedback.label.selectedItems')}: {selectedSendTo.length}</Typography>
                      <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <Typography fontSize={14} lineHeight="24px" color={itemsSendTo.length > 0 && selectedSendTo.length === itemsSendTo.length ? "#BEC2CB" : "#5DA196"} fontWeight="400px" onClick={handleSelectAllClickSendTo} mt="10px" sx={{ cursor: itemsSendTo.length > 0 && selectedSendTo.length === itemsSendTo.length ? "default" : "pointer" }}>
                          {t('label.selectAll')}
                        </Typography>
                        <Typography fontSize={14} lineHeight="24px" color={itemsSendTo.length > 0 && selectedSendTo.length > 0 ? "#5DA196" : "#BEC2CB"} fontWeight="400px" onClick={handleDeSelectAllClickSendTo} mt="10px" ml="20px" sx={{ cursor: itemsSendTo.length > 0 && selectedSendTo.length > 0 ? "pointer" : "default" }}>
                          {t('label.deSelectAll')}
                        </Typography>
                      </Box>
                      <Box mt="15px" sx={{ maxHeight: "270px", overflowY: "overlay", }} >
                        {focusSearchSendTo && itemsSendTo.length > 0 ? itemsSendTo.map((rs, index) => {
                          const isItemSelectedSendTo = isSelectedSendTo(rs)
                          return (
                            <Box sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
                              <Box sx={{ display: "flex", alignItems: "center" }}
                                onClick={(event) => handleClickSendTo(event, rs)}
                                role="checkbox"
                                aria-checked={isItemSelectedSendTo}
                                tabIndex={-1}
                                key={rs.serial}
                                selected={isItemSelectedSendTo}>
                                <Checkbox
                                  sx={{ padding: "0" }}
                                  // onChange={e => changeType(data?.serial)} 
                                  checked={isItemSelectedSendTo}
                                />
                              </Box>
                              <Typography fontSize={16} m="10px" mr="0px" width="100%" lineHeight="24px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                {Util.formatData(rs?.fullname, "")} <span style={{ paddingLeft: "10px", fontSize: "14px", lineHeight: "24px", fontWeight: "400", color: "#BEC2CB" }}>({Util.formatData(rs?.position, "")})</span>
                              </Typography>
                            </Box>
                          )
                        })
                          :
                          <Box sx={{ paddingTop: "10px", textAlign: "center" }}>
                            <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                              {t('label.notFund')}
                            </Typography>
                          </Box>
                        }
                      </Box>
                    </Box>
                  </Collapse>
                </Box>
              </Box>
            </ClickAwayListener>
            {formik.touched.sendTo && formik.errors.sendTo ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.sendTo} </FormHelperText>) : <></>}
          </Box>
          <Typography pt="20px" color="#404349" fontWeight="500" fontSize={16} lineHeight="20px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t('feedback.label.title')}<span style={{ color: "#CC6058 ", fontWeight: "400" }}> *</span></Typography>
          <TextField
            fullWidth
            helperText={formik.touched.title && formik.errors.title}
            error={Boolean(formik.touched.title && formik.errors.title)}
            margin="normal"
            name="title"
            onChange={formik.handleChange}
            type="text"
            value={formik.values.title}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            placeholder={t('feedback.label.fillTheTitle')}
            classes={{ root: classes.input }}
            sx={{ ".MuiOutlinedInput-root": { color: "#404349", borderRadius: "10px" }, ".MuiOutlinedInput-notchedOutline": { border: "1px solid #E4E7EA" } }}
            inputProps={{
              sx: {
                "&::placeholder": {
                  color: "#BEC2CB",
                  fontWeight: "300",
                  opacity: "1"
                }
              }
            }}
          />
          <Typography pt="20px" color="#404349" fontWeight="500" fontSize={16} lineHeight="20px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t('feedback.label.myFeedbackQuestion')}<span style={{ color: "#CC6058 ", fontWeight: "400" }}> *</span></Typography>
          {Util.formatData(loopQuestion, [].length > 0) ?
            loopQuestion.map((data, idx) =>
              <Box>
                <Box display="flex" alignItems="center" pt="20px">
                  <Typography color="#5DA196" fontWeight="500" fontSize={16} lineHeight="20px" sx={{ width: "40px" }}>Q{idx + 1}:</Typography>
                  <Box width="100%" sx={{ ".MuiFormControl-root": { "margin": "0" } }}>
                    <TextField
                      error={statusSave && Util.formatData(question[idx].question, false) === false}
                      fullWidth
                      margin="normal"
                      name="code"
                      onChange={e => onChange(e, idx)}
                      type="text"
                      value={question[idx].question}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      placeholder="Fill the feedback question"
                      classes={{ root: classes.input }}
                      sx={{ ".MuiOutlinedInput-root": { color: "#404349", borderRadius: "10px" }, ".MuiOutlinedInput-notchedOutline": { border: "1px solid #E4E7EA" } }}
                      inputProps={{
                        sx: {
                          "&::placeholder": {
                            color: "#BEC2CB",
                            fontWeight: "300",
                            opacity: "1"
                          }
                        }
                      }}
                    />
                    {statusSave && Util.formatData(question[idx].question, false) === false ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                  </Box>
                </Box>
                {/* <Typography fontWeight="500" color="#5DA196" fontSize={14} lineHeight="20.93px" sx={{ width: "calc(100% - 15px)", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content" }} >Q:{idx + 1}<span style={{ "padding-left": "5px" }}>{data?.question}</span></Typography> */}
                <Box pt="10px" pb="15px">
                  <Box sx={{ display: "flex", width: "100%" }} >
                    <Box width="100% ">
                      <Box pt="5px" maxWidth="900px" sx={{ display: "flex", overflowX: "auto", justifyContent: "space-between" }}>
                        {IconFeedback.map((rating, i) => (
                          <BootstrapTooltip key={i} title={<span style={{ "font-weight": "400", "font-size": "16px", "line-height": "21px", }}>{rating.label === "Angry" ? t('feedback.label.angry') : rating.label === "Bored" ? t('feedback.label.bored') : rating.label === "Lazy" ? t('feedback.label.lazy') : rating.label === "Worried" ? t('feedback.label.worried') : rating.label === "Disappointed" ? t('feedback.label.disappointed') : rating.label === "Accomplished" ? t('feedback.label.accomplished') : rating.label === "Loved" ? t('feedback.label.loved') : rating.label === "Joyful" ? t('feedback.label.joyful') : rating.label === "Happy" ? t('feedback.label.happy') : rating.label === "Excited" ? t('feedback.label.excited') : "-"}</span>} placement="top">
                            <Box className={`${classes.boxIcon}`} sx={{ backgroundColor: question[idx]?.emotion === rating.id ? "#5DA196" : "", height: "60px", borderRadius: "100px" }} >
                              <img width="60px" height="60px" src={rating?.icon} alt={rating?.label} style={{ display: "block", cursor: "pointer" }} onClick={e => onChanges(rating?.id, idx, "emotion")} />
                            </Box>
                          </BootstrapTooltip>
                        ))}
                      </Box>
                      <Box width="100% " sx={{ ".MuiFormControl-root": { "margin": "0" } }} pt="5px">
                        <TextField
                          error={statusSave && Util.formatData(question[idx].comment, false) === false && Util.formatData(question[idx].emotion, false) === false}
                          fullWidth
                          margin="normal"
                          name="code"
                          onChange={e => onChanges(e, idx, "comment")}
                          type="text"
                          value={question[idx].comment}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          multiline
                          minRows={3}
                          placeholder={t('label.fillYourFeedback')}
                          classes={{ root: classes.input }}
                          sx={{ ".MuiOutlinedInput-root": { color: "#404349", borderRadius: "10px", padding: "10px 15px" }, ".MuiOutlinedInput-notchedOutline": { border: "1px solid #E4E7EA" } }}
                          inputProps={{
                            sx: {
                              "&::placeholder": {
                                color: "#BEC2CB",
                                fontWeight: "300",
                                opacity: "1"
                              }
                            }
                          }}
                        />
                        {statusSave && Util.formatData(question[idx].comment, false) === false && Util.formatData(question[idx].emotion, false) === false ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            )
            :
            null
          }
          <Box pt="20px" display="flex" justifyContent="center">
            <Box mr={2} sx={{ width: "210px" }}>
              <Button color="black" variant="outlined" onClick={handleCancel} fullWidth sx={{ textTransform: "none" }}>
                {t("label.cancel")}
              </Button>
            </Box>
            <Box sx={{ width: "210px" }}>
              <Button color="primary" variant="contained" onClick={handleSubmit} fullWidth sx={{ textTransform: "none" }}>
                {t("label.send")}
              </Button>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <ConfirmDialog open={confirmSendDialog} warning={true} doConfirm={() => handleSendConfirm()} setValue={() => handleConfirmSendDialog(false)} title={t('feedback.label.confirmation')} text={t('feedback.label.areYouSureToGiveFeedback')} />
      <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t("corporateGoal.label.dialog.discardTitle")} text={t("corporateGoal.label.dialog.discardText")} />
    </Dialog>
  );
};
export default DialogGiveFeedback;
